import { put, takeLatest } from 'redux-saga/effects'
import LocalStorageWrapper, { LocalStorageItem } from '../../../common/assets/utils/LocalStorageWrapper'
import { bffParceirosApiService } from '../../../services/bff'
import PublicConfigurationsSliceReducer, { PublicConfigurations } from './public-configurations.reducer'

function* fetchConfigurations() {
  try {
    const localStoragePublicConfigurations: PublicConfigurations = LocalStorageWrapper.getItem(LocalStorageItem.PUBLIC_CONFIGURATIONS)

    if (localStoragePublicConfigurations) {
      yield put(PublicConfigurationsSliceReducer.actions.fetchConfigurationsSuccess(localStoragePublicConfigurations))
    }

    const publicConfigurations: PublicConfigurations = yield bffParceirosApiService.publicConfigurations.fetchPublicConfigurations()

    if (publicConfigurations) {
      LocalStorageWrapper.setItem(LocalStorageItem.PUBLIC_CONFIGURATIONS, publicConfigurations)
    }

    document.title = String(publicConfigurations?.app?.name)

    yield put(PublicConfigurationsSliceReducer.actions.fetchConfigurationsSuccess(publicConfigurations))
  } catch (error) {
    yield put(PublicConfigurationsSliceReducer.actions.fetchConfigurationsError(error))
  }
}

const publicConfigurationsSaga = [
  takeLatest(PublicConfigurationsSliceReducer.actions.fetchConfigurations, fetchConfigurations),
]

export default publicConfigurationsSaga
